module.exports = __webpack_public_path__ + "static/img/device-4.3a5cdb4.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/device-4.png
// module id = k2sa
// module chunks = 0